import { render, staticRenderFns } from "./binsFormPage.vue?vue&type=template&id=a8365f8a&scoped=true&"
import script from "./binsFormPage.vue?vue&type=script&lang=js&"
export * from "./binsFormPage.vue?vue&type=script&lang=js&"
import style0 from "./binsFormPage.vue?vue&type=style&index=0&id=a8365f8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8365f8a",
  null
  
)

export default component.exports